var transformRTL = function transformRTL(isRTL, a, b) {
  return isRTL ? b : a;
};
export var transformPlacement = function transformPlacement(isRTL, placement) {
  var _placement;
  switch (placement) {
    case 'top-start':
      _placement = transformRTL(isRTL, 'top-start', 'top-end');
      break;
    case 'top-end':
      _placement = transformRTL(isRTL, 'top-end', 'top-start');
      break;
    case 'bottom-start':
      _placement = transformRTL(isRTL, 'bottom-start', 'bottom-end');
      break;
    case 'bottom-end':
      _placement = transformRTL(isRTL, 'bottom-end', 'bottom-start');
      break;
    case 'left':
      _placement = transformRTL(isRTL, 'left', 'right');
      break;
    case 'left-start':
      _placement = transformRTL(isRTL, 'left-start', 'right-start');
      break;
    case 'left-end':
      _placement = transformRTL(isRTL, 'left-end', 'right-start');
      break;
    case 'right':
      _placement = transformRTL(isRTL, 'right', 'left');
      break;
    case 'right-start':
      _placement = transformRTL(isRTL, 'right-start', 'left-start');
      break;
    case 'right-end':
      _placement = transformRTL(isRTL, 'right-end', 'left-end');
      break;
    case 'auto-start':
      _placement = transformRTL(isRTL, 'auto-start', 'auto-end');
      break;
    case 'auto-end':
      _placement = transformRTL(isRTL, 'auto-end', 'auto-start');
      break;
    default:
      _placement = placement;
      break;
  }
  return _placement;
};